module.exports = __webpack_public_path__ + "static/media/GABA_Post_2018.10.01.c9e07be8.jpg";